var render = function render(){var _vm=this,_c=_vm._self._c;return _c('xz-table',{ref:"ordersRef",attrs:{"columns":_vm.columns,"data":_vm.tableData,"scroll":{ x: '100%', y: 540 },"rowKey":'id'}})
}
var staticRenderFns = []

export { render, staticRenderFns }